export default __webpack_public_path__ + "static/ombralsun-4-f9539b5a9fefe9d6dd119483b08d863b.jpg";